import { isTrueStringMatch } from 'apps/builder/lib/utils'
import { lib } from '@gocanvas/client'
const { MULTIPLE_ENTRY_SECTION_TYPE_ID } = lib

export const orderByPosition = (first, second) =>
  first.position - second.position

const compareNumbers = (a, b) => a - b

// inRange :: (Int, Int, Int) -> Boolean
export const inRange = (first, second, test) =>
  (test - first) * (test - second) <= 0

// given any items original position and its new position and the position of any given entry, determine
// where the new position of any given entry should be
// reIndex :: (Int, Int, Int) -> Int
export const reIndex = (originalPosition, newPosition, entryPosition) => {
  const movedBack = originalPosition > newPosition
  const effected = inRange(originalPosition, newPosition, entryPosition)
  // If the entry position is between the new and old indexes it needs
  // to be updated
  if (effected) {
    return movedBack ? entryPosition + 1 : entryPosition - 1
  }

  return entryPosition
}

// updates position of all items if their position was above a removed item
// not passing a sheetId means it will run on all items, otherwise it runs only
// on items with a match sheetID
// reIndexOnDelete :: Array -> Array
export const reIndexOnDelete = (entries, oldPosition, sheetId) =>
  entries.map(entry => {
    if (!sheetId || isTrueStringMatch(entry.sheet_id, sheetId)) {
      const position =
        oldPosition < entry.position ? entry.position - 1 : entry.position
      return {
        ...entry,
        position,
      }
    } else {
      return entry
    }
  })

// reIndexByMatch:: (Array, Function -> Boolean, Integer, Integer) -> Array
export const reIndexByMatch = (entries, test, newPosition, oldPosition) => {
  return entries
    .map(entry => {
      if (test(entry)) {
        return {
          ...entry,
          position: newPosition,
        }
      } else {
        const position = reIndex(oldPosition, newPosition, entry.position)
        return {
          ...entry,
          position,
        }
      }
    })
    .sort(orderByPosition)
}

export const multiSectionFilter = ({ section_type_id }) => {
  const multiSectionIds = [MULTIPLE_ENTRY_SECTION_TYPE_ID]

  return !multiSectionIds.includes(section_type_id)
}

export const sortBy = (group, type, accessor) => {
  const sortTypes = {
    asc: (a, b) => {
      if (a < b) {
        return -1
      }
      if (a > b) {
        return 1
      }
      return 0
    },
    desc: (a, b) => {
      if (a > b) {
        return -1
      }
      if (a < b) {
        return 1
      }
      return 0
    },
  }
  return group.sort((entry1, entry2) => {
    return sortTypes[type](accessor(entry1), accessor(entry2))
  })
}

//affectedEntrySetByGuid :: (Arary, Array) -> Set
export const affectedEntrySetByGuid = (allEntries, affectedSheetIds = []) => {
  const affectedSheetIdSet = new Set(affectedSheetIds.map(String))
  return allEntries.reduce((acc, { sheet_id, guid }) => {
    if (affectedSheetIdSet.has(String(sheet_id))) {
      acc.add(guid)
    }
    return acc
  }, new Set())
}
